(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class ProductCardSlider extends HTMLElement {
    connectedCallback() {
      const slider = this.querySelector('.product-card__slider');
      const dots = this.querySelectorAll('.product-card__slider-dot');
      const prevBtn = this.querySelector('.product-card__slider-arrow--prev');
      const nextBtn = this.querySelector('.product-card__slider-arrow--next');

      if (!slider) return;

      const slideCount = this.querySelectorAll('.product-card__slide').length;
      let imagesLoaded = false;

      const loadImages = () => {
        if (imagesLoaded) return;
        imagesLoaded = true;
        slider.querySelectorAll('img[data-srcset]').forEach(img => {
          img.srcset = img.dataset.srcset;
          img.sizes = img.dataset.sizes;
          img.removeAttribute('data-srcset');
          img.removeAttribute('data-sizes');
        });
      };

      const currentIndex = () => {
        const width = slider.clientWidth;
        return width ? Math.min(Math.round(slider.scrollLeft / width), slideCount - 1) : 0;
      };

      const goTo = index => {
        slider.scrollTo({ left: index * slider.clientWidth, behavior: 'smooth' });
      };

      const update = () => {
        const index = currentIndex();
        dots.forEach((dot, i) => dot.classList.toggle('is-selected', i === index));
        if (prevBtn) prevBtn.toggleAttribute('disabled', index === 0);
        if (nextBtn) nextBtn.toggleAttribute('disabled', index === slideCount - 1);
      };

      update();

      let rafId;
      slider.addEventListener('scroll', () => {
        loadImages();
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(update);
      }, { passive: true });

      this.addEventListener('pointerenter', loadImages, { once: true });

      if (prevBtn) {
        prevBtn.addEventListener('click', e => {
          e.preventDefault();
          loadImages();
          goTo(currentIndex() - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', e => {
          e.preventDefault();
          loadImages();
          goTo(currentIndex() + 1);
        });
      }
    }
  }

  if (!customElements.get('product-card-slider')) {
    customElements.define('product-card-slider', ProductCardSlider);
  }
  } catch(e) { console.error(e); }
})();

})();
